import { ResultsPerPage as ResultsPerPageComponent } from '@coveo/headless';
import { Select, SelectOption } from '@lmig/lmds-react-select';
import { Grid } from '@mui/material';
interface IResultsPerPageProps {
  resultsPerPage: React.MutableRefObject<ResultsPerPageComponent>;
  show: boolean;
}
export default function ResultsPerPage({ resultsPerPage, show }: IResultsPerPageProps) {
  return (
    <>
      {show && (
        <div className="results-per-page">
          <Grid container alignContent="center" alignItems="center">
            <div className="bold">Rows displayed: </div>
            <Select
              id="search-page-sort"
              className="search-per-page-selector select-no-label"
              labelVisual=""
              defaultValue="10"
              onChange={(event: React.FormEvent<HTMLSelectElement>) => {
                resultsPerPage.current!.set(parseInt(event.currentTarget.value, 10));
              }}
            >
              <SelectOption value="10">10</SelectOption>
              <SelectOption value="20">20</SelectOption>
              <SelectOption value="50">50</SelectOption>
            </Select>
          </Grid>
        </div>
      )}
    </>
  );
}
